import { createReducer } from '@reduxjs/toolkit';

import { CONTRACT_AUTHENTICATION_INITIALIZE } from '@app/store/actionTypes';
import {
  fetchContractAuthentication,
  fetchMessageFromRequester,
} from '@app/store/contract-authentication/actions';

export type ContractAuthenticationDocumentIdState = string | null;

const initialState: ContractAuthenticationDocumentIdState = null;

const reducer = createReducer<ContractAuthenticationDocumentIdState>(initialState, (builder) =>
  builder
    .addCase(CONTRACT_AUTHENTICATION_INITIALIZE, () => initialState)
    .addCase(fetchMessageFromRequester.pending, (_, action) => {
      return action.meta.arg.documentId;
    })
    .addCase(fetchContractAuthentication.pending, (_, action) => action.meta.arg.documentId)
);

export default reducer;
